export const GET_USER_MANAGEMENT_TABLE = "GET_USER_MANAGEMENT_TABLE";
export const SEND_VERIFICATION_EMAIL = "SEND_VERIFICATION_EMAIL";
export const SEND_VERIFICATION_EMAIL_ONLY = "SEND_VERIFICATION_EMAIL_ONLY";
export const SEND_VERIFICATION_SMS_ONLY = "SEND_VERIFICATION_SMS_ONLY";
export const UPDATE_USER_STATUS = "UPDATE_USER_STATUS";
export const DELETE_USER = "DELETE_USER";
export const CREATE_USER = "CREATE_USER";
export const MODIFY_USER = "MODIFY_USER";
export const IMPORT_USERS_FROM_EXCEL = "IMPORT_USERS_FROM_EXCEL";
export const GET_LICENSE_SUMMARY = "GET_LICENSE_SUMMARY";
export const GET_LICENSE_PACKAGES = "GET_LICENSE_PACKAGES";
export const REACTIVATE_USER = "REACTIVATE_USER";